import { ApiOutlined, CopyOutlined, SlackOutlined } from "@ant-design/icons";
import { Button, Tag, Tooltip, Typography } from "antd";
import { useEffect, useState } from "react";

import { useExceptionHandler } from "../../../../hooks/useExceptionHandler";
import { useAlertStore } from "../../../../store/alert-store";
import { useSessionStore } from "../../../../store/session-store";
import { useAxiosPrivate } from "../../../../hooks/useAxiosPrivate";
import { LLM_WHISPERER_ENDPOINT } from "../../helper";

function SupportComponent() {
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();
  const [textToCopy, setTextToCopy] = useState(null);
  const [revealed, setRevealed] = useState(false);
  const { Text } = Typography;

  const getGatewayURL = () => {
    const requestOptions = {
      method: "GET",
      url: `${LLM_WHISPERER_ENDPOINT}/api-gateway-url/`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
      },
    };
    axiosPrivate(requestOptions)
      .then((res) => {
        const data = res?.data;
        const gatewayURL = data?.api_gateway_url;
        if (gatewayURL) {
          setTextToCopy(gatewayURL);
        }
      })
      .catch((err) => {
        setAlertDetails(
          handleException(err, "Failed to fetch daily usage metrics")
        );
      });
  };

  const copyText = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setAlertDetails({
          type: "success",
          content: "LLMWhisperer public URL copied to clipboard",
        });
        setRevealed(true);
      })
      .catch((error) => {
        setAlertDetails({
          type: "error",
          content: "Copy failed",
        });
      });
  };

  useEffect(() => {
    getGatewayURL();
  }, []);

  return (
    <>
      <div>
        {!revealed ? (
          <Tooltip title={"Click to copy"}>
            <Button
              type="link"
              icon={<CopyOutlined />}
              onClick={() => copyText(textToCopy)}
            >
              LLMWhisperer API URL
            </Button>
          </Tooltip>
        ) : (
          <Tag color="blue">
            <Text>{textToCopy}</Text>
          </Tag>
        )}
      </div>
      <Button
        type="link"
        icon={<ApiOutlined />}
        onClick={() =>
          window.open("https://docs.unstract.com/llmwhisperer/", "_blank")
        }
      >
        API Documentation
      </Button>
      <Button
        shape="circle"
        icon={<SlackOutlined />}
        type="link"
        onClick={() =>
          window.open("https://join-slack.unstract.com/", "_blank")
        }
      >
        Slack Community
      </Button>
    </>
  );
}

export { SupportComponent };
